module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parlay-textbox-and-button",
    staticClass: "rounded-sm",
    class: [_vm.keepFocusClass, _vm.fillRemainingClass, _vm.noBordersClass]
  }, [_c('div', {
    ref: "parlay-textbox-container",
    staticClass: "relative",
    class: [_vm.fillRemainingClass, _vm.minHeightClass],
    style: ({
      maxHeight: (_vm.maxHeight + "px")
    })
  }, [_c('textarea', {
    ref: "parlay-textbox",
    staticClass: "rounded border-2 border-slate-300 placeholder-slate-400",
    style: (_vm.textAreaStyle),
    attrs: {
      "data-gramm": "false",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "maxLength": _vm.maxLength,
      "rows": "6"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateMessage,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "keydown": _vm.newline
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "invisible-text"
  }, [_vm._v(_vm._s(' ' + _vm.value + ' '))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allowEmoji),
      expression: "allowEmoji"
    }]
  }, [(_vm.allowEmoji && _vm.chatIsEnabled) ? _c('emoji-picker', {
    staticClass: "emoji-container",
    attrs: {
      "search": _vm.search
    },
    on: {
      "emoji": _vm.append
    },
    scopedSlots: _vm._u([{
      key: "emoji-invoker",
      fn: function(ref) {
        var clickEvent = ref.events.click;

        return _c('div', {
          staticClass: "emoji-invoker",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return clickEvent.apply(null, arguments)
            }
          }
        }, [_c('svg', {
          attrs: {
            "height": "24",
            "viewBox": "0 0 24 24",
            "width": "24",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M0 0h24v24H0z",
            "fill": "none"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
          }
        })])])
      }
    }, {
      key: "emoji-picker",
      fn: function(ref) {
        var emojis = ref.emojis;
        var insert = ref.insert;
        var display = ref.display;

        return _c('div', {}, [_c('div', {
          staticClass: "emoji-picker",
          style: ({
            top: display.y + 'px',
            left: display.x + 'px'
          })
        }, [_c('div', {
          staticClass: "emoji-picker__search"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.search),
            expression: "search"
          }, {
            name: "focus",
            rawName: "v-focus"
          }],
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (_vm.search)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.search = $event.target.value
            }
          }
        })]), _vm._v(" "), _c('div', _vm._l((emojis), function(emojiGroup, category) {
          return _c('div', {
            key: category
          }, [_c('h5', [_vm._v(_vm._s(category))]), _vm._v(" "), _c('div', {
            staticClass: "emojis"
          }, _vm._l((emojiGroup), function(emoji, emojiName) {
            return _c('span', {
              key: emojiName,
              attrs: {
                "title": emojiName
              },
              on: {
                "click": function($event) {
                  return insert(emoji)
                }
              }
            }, [_vm._v(_vm._s(emoji))])
          }), 0)])
        }), 0)])])
      }
    }], null, false, 4235467329)
  }) : _c('div', {
    staticClass: "emoji-container emoji-invoker-blocked"
  }, [_c('svg', {
    attrs: {
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    }
  })])])], 1)]), _vm._v(" "), (_vm.showSubmitButton) ? _c('div', {
    staticClass: "text-box-button-row end-xs items-center row no-margin no-padding",
    on: {
      "click": _vm.focusTextarea
    }
  }, [_c('span', {
    staticClass: "pl-caption italics col-xs-7 start-xs"
  }, [_vm._v("\n      " + _vm._s(_vm.submittingMessage))]), _vm._v(" "), _c('div', {
    staticClass: "flex-container-end"
  }, [(_vm.savedChanges) ? _c('div', [(_vm.autoSave) ? _c('pl-button', {
    ref: "textbox-button",
    attrs: {
      "disabled": true
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendMessage(_vm.text)
      }
    }
  }, [_vm._v("\n          Saved\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('pl-button', {
    ref: "textbox-button",
    class: [_vm.theme],
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendMessage(_vm.text)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonTitle) + "\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-45d56581!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/textbox.vue
// module id = 919
// module chunks = 61